import { css } from 'styled-components';

import { basicTheme, createTheme } from './basicTheme';

const colors = {
  primary: '#22c993',
  primaryHover: '#46d5a8',
  primaryActive: '#1eb685',
  secondary: '#bbefde',
  tertiary: '#9ea9b2',
  header: {
    bg: basicTheme.colors.white,
    text: basicTheme.colors.textPrimary,
    searchbar: '#bbefde' //temp
  },
  get sidebar() {
    return {
      bg: this.primary,
      icon: this.secondary,
      delimiter: '#46d4a7',
      focusedColor: basicTheme.colors.white,
      iconHoverBackground: 'transparent'
    };
  },
  get iconActive() {
    return this.primary;
  },
  get loader() {
    return this.primary;
  },
  get combobox() {
    return {
      selected: this.secondary,
      focusBorder: this.primary
    };
  }
};

const borders = {
  header: `1px solid ${basicTheme.colors.iceBlueTwo}`
};

export const buttons = {
  primary: {
    borderRadius: 2,
    background: colors.primary,
    color: basicTheme.colors.white,
    '&:hover': {
      background: '#46d5a8'
    },
    '&:active': {
      background: '#76e0be'
    },
    '&:disabled': {
      color: basicTheme.colors.cloudyBlueTwo,
      background: basicTheme.colors.iceBlueTwo
    }
  },
  outline: {
    borderRadius: 2,
    border: `1px solid ${colors.primary}`,
    color: colors.primary,
    '&:hover': {
      background: basicTheme.colors.aquaSpring
    },
    '&:active': {
      background: '#d9f7ee'
    },
    '&:disabled': {
      color: basicTheme.colors.cloudyBlueTwo,
      border: `1px solid ${basicTheme.colors.cloudyBlueTwo}`
    }
  },
  ghost: {
    color: colors.primary,
    '&:hover': {
      background: basicTheme.colors.aquaSpring
    },
    '&:active': {
      background: '#d9f7ee'
    },
    '&:disabled': {
      color: basicTheme.colors.cloudyBlueTwo
    }
  }
};

export const radioButtons = {
  secondary: css`
    & > .fake-radio-button {
      min-width: 100%;
      border: 1px solid;
      border-color: ${basicTheme.colors.iceBlueTwo};
      border-radius: 4px;
      color: ${basicTheme.colors.textSecondary};
    }
    & > input:not(:disabled):not(:checked) + .fake-radio-button {
      &:hover {
        background-color: ${colors.primary};
        border-color: ${colors.primary};
        color: ${basicTheme.colors.white};
      }
    }
    &:not(:last-child) > .fake-radio-button {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
    &:not(:first-child) > .fake-radio-button {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
    &:not(:last-child) > input:not(:checked):not(:disabled) + .fake-radio-button {
      border-right: none;
    }
    &.checked + & > .fake-radio-button,
    &.disabled + & > input:not(:checked) + .fake-radio-button {
      border-left: none;
    }
    & > input:checked + .fake-radio-button {
      border-color: ${colors.primary};
      background-color: ${colors.secondary};
    }
    & > input:disabled + .fake-radio-button {
      background-color: ${basicTheme.colors.iceBlueTwo};
      border-color: ${basicTheme.colors.cloudyBlueTwo};
      color: ${basicTheme.colors.cloudyBlueTwo};
      cursor: not-allowed;
    }
  `,
  get tertiary() {
    return css`
      ${this.secondary};
      & > input:disabled + .fake-radio-button {
        background-color: initial;
        border-color: ${basicTheme.colors.iceBlueTwo};
      }
    `;
  }
};

const links = {
  subnav: css`
    color: ${basicTheme.colors.textSecondary};
    font-size: 14px;
    font-weight: ${basicTheme.fontWeights.normal};

    &:hover,
    &.active {
      font-weight: ${basicTheme.fontWeights.bold};
      color: ${basicTheme.colors.textPrimary};
    }
  `
};

export const candidateTheme = createTheme({
  colors,
  borders,
  buttons,
  radioButtons,
  links
});
